import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeTravaux } from '../models/TypeTravaux';
@Component({
  selector: 'app-type-travaux',
  templateUrl: './type-travaux.component.html'
})
export class TypeTravauxComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeTravaux'
  @Input() parentForm: FormGroup;
  	@Input() marcheTravaux : TypeTravaux;

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

